import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import ComponentDetails from "../../Library/ComponentDetails";
import InfoIcon from "../../../assets/icons/info-01.svg2";
import MyModal from "../../Common/MyModal";

export default function ComponentInfoPopup({ component }: { component: any }) {
  return (
    <MyModal
      heading="Component Details"
      modalClassName="bg-purple-gradient p-3"
      label={<InfoIcon width={15} className="me-1" />}
    >
      <ComponentDetails project={component} />
    </MyModal>
    // <OverlayTrigger
    //   trigger="click"
    //   placement={"auto"}
    //   rootClose
    //   overlay={
    //     <Popover
    //       className="bg-purple-gradient"
    //       id={`popover-component-info-${component.UUID}`}
    //       style={{ maxWidth: "70vw" }}
    //     >
    //       <Popover.Header as="h3">{component.Label}</Popover.Header>
    //       <Popover.Body className="p-3">
    //         <ComponentDetails project={component} />
    //       </Popover.Body>
    //     </Popover>
    //   }
    // >
    //   <Button className="btn-sm p-0 m-1 bg-transparent border-0">
    //     <InfoIcon width={15} />
    //   </Button>
    // </OverlayTrigger>
  );
}
